/**
 * GENERATED FILE — do not hand-edit. Regenerate with:
 *   node scripts/import-pricing-rules.mjs <path-to-designer-portal-checkout>
 *
 * Compiled-in FALLBACK for the CV pricing business rules (ADR 0058; the
 * Designer Portal repo's docs/PRICING_AND_INTERIORS_PLAN.md §1.4). These are
 * the offline seeds — the admin-maintained sketch.business_rules rows
 * override them at runtime, exactly like every other rule fallback in
 * src/config/business-rules.js. Prices are DATA imported from the portal's
 * canonical parser outputs, never typed here.
 *
 * Source: Designer Portal checkout data/cv-pricing/* (parser baseline
 * "pricing-info-20260808-2231.xlsx", export date 2026-08-08)
 * Checkout: C:/tmp/cv-owner-answers-wt
 * Checkout HEAD: 3a103ba0cedc52fe00f8e509e37fe038d744508e
 * Generated: 2026-08-09T07:11:35.937Z
 */

/** The canonical CV section catalog (plan §2 row shape; 165 rows). */
export const CV_SECTION_CATALOG = Object.freeze({
  "exportDate": "2026-08-08",
  "source": "pricing-info-20260808-2231.xlsx",
  "sections": [
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 18,
      "config": "DRW-2F",
      "configName": "Drawers  (2 File drawers)",
      "className": "Base Section",
      "price": 751,
      "materialPrice": 751,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_18_DRW-2F"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DRW3",
      "configName": "3 Drawers",
      "className": "Base Section",
      "price": 901,
      "materialPrice": 901,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_24_DRW3"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1106,
      "materialPrice": 1106,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_24_DRW4"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 24,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Base Section",
      "price": 271,
      "materialPrice": 271,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_24_FS"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 24,
      "config": "FS-2dr",
      "configName": "Flat Shelves w 2 doors",
      "className": "Base Section",
      "price": 383,
      "materialPrice": 383,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_24_FS-2dr"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DRW3",
      "configName": "3 Drawers",
      "className": "Base Section",
      "price": 993,
      "materialPrice": 993,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_36_DRW3"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1200,
      "materialPrice": 1200,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_36_DRW4"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 36,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Base Section",
      "price": 351,
      "materialPrice": 351,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_36_FS"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 36,
      "config": "FS-2dr",
      "configName": "Flat Shelves w 2 doors",
      "className": "Base Section",
      "price": 500,
      "materialPrice": 500,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_36_FS-2dr"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Base Section",
      "price": 816,
      "materialPrice": 816,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_16_36_LSh"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 16,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Base Section",
      "price": 106,
      "materialPrice": 106,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "B_28.5_16_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 20,
      "widthIn": 18,
      "config": "DRW-2F",
      "configName": "Drawers  (2 File drawers)",
      "className": "Base Section",
      "price": 792,
      "materialPrice": 792,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_20_18_DRW-2F"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 20,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Base Section",
      "price": 123,
      "materialPrice": 123,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "B_28.5_20_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 18,
      "config": "DRW-2F",
      "configName": "Drawers  (2 File drawers)",
      "className": "Base Section",
      "price": 834,
      "materialPrice": 834,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_18_DRW-2F"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 24,
      "config": "DRW3",
      "configName": "3 Drawers",
      "className": "Base Section",
      "price": 1009,
      "materialPrice": 1009,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_24_DRW3"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1231,
      "materialPrice": 1231,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_24_DRW4"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 24,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Base Section",
      "price": 345,
      "materialPrice": 345,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_24_FS"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 24,
      "config": "FS-2dr",
      "configName": "Flat Shelves w 2 doors",
      "className": "Base Section",
      "price": 458,
      "materialPrice": 458,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_24_FS-2dr"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 36,
      "config": "DRW3",
      "configName": "3 Drawers",
      "className": "Base Section",
      "price": 1119,
      "materialPrice": 1119,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_36_DRW3"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1342,
      "materialPrice": 1342,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_36_DRW4"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 36,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Base Section",
      "price": 453,
      "materialPrice": 453,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_36_FS"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": 36,
      "config": "FS-2dr",
      "configName": "Flat Shelves w 2 doors",
      "className": "Base Section",
      "price": 601,
      "materialPrice": 601,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_22_36_FS-2dr"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 22,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Base Section",
      "price": 128,
      "materialPrice": 128,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "B_28.5_22_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 18,
      "config": "DRW-2F",
      "configName": "Drawers  (2 File drawers)",
      "className": "Base Section",
      "price": 853,
      "materialPrice": 853,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_18_DRW-2F"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 24,
      "config": "DRW3",
      "configName": "3 Drawers",
      "className": "Base Section",
      "price": 1032,
      "materialPrice": 1032,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_24_DRW3"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1254,
      "materialPrice": 1254,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_24_DRW4"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 24,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Base Section",
      "price": 374,
      "materialPrice": 374,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_24_FS"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 24,
      "config": "FS-2dr",
      "configName": "Flat Shelves w 2 doors",
      "className": "Base Section",
      "price": 486,
      "materialPrice": 486,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_24_FS-2dr"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 36,
      "config": "DRW3",
      "configName": "3 Drawers",
      "className": "Base Section",
      "price": 1147,
      "materialPrice": 1147,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_36_DRW3"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1371,
      "materialPrice": 1371,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_36_DRW4"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 36,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Base Section",
      "price": 490,
      "materialPrice": 490,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_36_FS"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": 36,
      "config": "FS-2dr",
      "configName": "Flat Shelves w 2 doors",
      "className": "Base Section",
      "price": 639,
      "materialPrice": 639,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_28.5_24_36_FS-2dr"
    },
    {
      "class": "B",
      "heightIn": 28.5,
      "depthIn": 24,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Base Section",
      "price": 139,
      "materialPrice": 139,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "B_28.5_24_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": 18,
      "config": "DRW3-2F",
      "configName": "3 Drawers (2 file drawers)",
      "className": "Base Section",
      "price": 972,
      "materialPrice": 972,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_16_18_DRW3-2F"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DRW-2dr",
      "configName": "1 Drawer w 2 doors",
      "className": "Base Section",
      "price": 645,
      "materialPrice": 645,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_16_24_DRW-2dr"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1125,
      "materialPrice": 1125,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_16_24_DRW4"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Base Section",
      "price": 319,
      "materialPrice": 319,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_16_24_ShOp"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DRW-2dr",
      "configName": "1 Drawer w 2 doors",
      "className": "Base Section",
      "price": 790,
      "materialPrice": 790,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_16_36_DRW-2dr"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1228,
      "materialPrice": 1228,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_16_36_DRW4"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Base Section",
      "price": 849,
      "materialPrice": 849,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_16_36_LSh"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Base Section",
      "price": 423,
      "materialPrice": 423,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_16_36_ShOp"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 16,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Base Section",
      "price": 106,
      "materialPrice": 106,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "B_35_16_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": 18,
      "config": "DRW3-2F",
      "configName": "3 Drawers (2 file drawers)",
      "className": "Base Section",
      "price": 995,
      "materialPrice": 995,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_20_18_DRW3-2F"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": 24,
      "config": "DRW-2dr",
      "configName": "1 Drawer w 2 doors",
      "className": "Base Section",
      "price": 711,
      "materialPrice": 711,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_20_24_DRW-2dr"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1178,
      "materialPrice": 1178,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_20_24_DRW4"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Base Section",
      "price": 382,
      "materialPrice": 382,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_20_24_ShOp"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": 36,
      "config": "DRW-2dr",
      "configName": "1 Drawer w 2 doors",
      "className": "Base Section",
      "price": 881,
      "materialPrice": 881,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_20_36_DRW-2dr"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1292,
      "materialPrice": 1292,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_20_36_DRW4"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Base Section",
      "price": 881,
      "materialPrice": 881,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_20_36_LSh"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Base Section",
      "price": 510,
      "materialPrice": 510,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_20_36_ShOp"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 20,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Base Section",
      "price": 123,
      "materialPrice": 123,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "B_35_20_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": 18,
      "config": "DRW3-2F",
      "configName": "3 Drawers (2 file drawers)",
      "className": "Base Section",
      "price": 1082,
      "materialPrice": 1082,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_22_18_DRW3-2F"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": 24,
      "config": "DRW-2dr",
      "configName": "1 Drawer w 2 doors",
      "className": "Base Section",
      "price": 754,
      "materialPrice": 754,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_22_24_DRW-2dr"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1250,
      "materialPrice": 1250,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_22_24_DRW4"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Base Section",
      "price": 411,
      "materialPrice": 411,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_22_24_ShOp"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": 36,
      "config": "DRW-2dr",
      "configName": "1 Drawer w 2 doors",
      "className": "Base Section",
      "price": 935,
      "materialPrice": 935,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_22_36_DRW-2dr"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1370,
      "materialPrice": 1370,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_22_36_DRW4"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Base Section",
      "price": 892,
      "materialPrice": 892,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_22_36_LSh"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Base Section",
      "price": 551,
      "materialPrice": 551,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_22_36_ShOp"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 22,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Base Section",
      "price": 128,
      "materialPrice": 128,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "B_35_22_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": 18,
      "config": "DRW3-2F",
      "configName": "3 Drawers (2 file drawers)",
      "className": "Base Section",
      "price": 1071,
      "materialPrice": 1071,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_24_18_DRW3-2F"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": 24,
      "config": "DRW-2dr",
      "configName": "1 Drawer w 2 doors",
      "className": "Base Section",
      "price": 788,
      "materialPrice": 788,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_24_24_DRW-2dr"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1273,
      "materialPrice": 1273,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_24_24_DRW4"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Base Section",
      "price": 446,
      "materialPrice": 446,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_24_24_ShOp"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": 36,
      "config": "DRW-2dr",
      "configName": "1 Drawer w 2 doors",
      "className": "Base Section",
      "price": 981,
      "materialPrice": 981,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_24_36_DRW-2dr"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Base Section",
      "price": 1399,
      "materialPrice": 1399,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_24_36_DRW4"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Base Section",
      "price": 913,
      "materialPrice": 913,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_24_36_LSh"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Base Section",
      "price": 597,
      "materialPrice": 597,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "B_35_24_36_ShOp"
    },
    {
      "class": "B",
      "heightIn": 35,
      "depthIn": 24,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Base Section",
      "price": 139,
      "materialPrice": 139,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "B_35_24_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "CS",
      "heightIn": null,
      "depthIn": 12,
      "widthIn": null,
      "config": "CS",
      "configName": "Connecting Shelves",
      "className": "Connecting Shelves",
      "price": 46,
      "materialPrice": 46,
      "nonMaterialPrice": 0,
      "perPricing": "Section",
      "source": "CS_NA_12_NA_NA"
    },
    {
      "class": "CS",
      "heightIn": null,
      "depthIn": 16,
      "widthIn": null,
      "config": "CS",
      "configName": "Connecting Shelves",
      "className": "Connecting Shelves",
      "price": 58,
      "materialPrice": 58,
      "nonMaterialPrice": 0,
      "perPricing": "Section",
      "source": "CS_NA_16_NA_NA"
    },
    {
      "class": "ST",
      "heightIn": 24,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Stacked",
      "price": 415,
      "materialPrice": 415,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "ST_24_12_36_ShDr"
    },
    {
      "class": "ST",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": 24,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Stacked",
      "price": 401,
      "materialPrice": 401,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "ST_36_12_24_ShDr"
    },
    {
      "class": "ST",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Stacked",
      "price": 258,
      "materialPrice": 258,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "ST_36_12_24_ShOp"
    },
    {
      "class": "ST",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Stacked",
      "price": 312,
      "materialPrice": 312,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "ST_36_12_36_ShOp"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 24,
      "config": "AngSh",
      "configName": "Angled Shelves",
      "className": "Tall Section",
      "price": 1176,
      "materialPrice": 1176,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_24_AngSh"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 24,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 392,
      "materialPrice": 392,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_24_DH"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 24,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Tall Section",
      "price": 448,
      "materialPrice": 448,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_24_FS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 24,
      "config": "FSS",
      "configName": "Flat Shoe Shelves",
      "className": "Tall Section",
      "price": 594,
      "materialPrice": 594,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_24_FSS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 36,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 455,
      "materialPrice": 455,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_36_DH"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ESS",
      "configName": "Elite Shoe Shelves",
      "className": "Tall Section",
      "price": 1479,
      "materialPrice": 959,
      "nonMaterialPrice": 520,
      "perPricing": "Section +1P",
      "source": "T_84_12_36_ESS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 36,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Tall Section",
      "price": 583,
      "materialPrice": 583,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_36_FS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 36,
      "config": "FSS",
      "configName": "Flat Shoe Shelves",
      "className": "Tall Section",
      "price": 801,
      "materialPrice": 801,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_36_FSS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Tall Section",
      "price": 1902,
      "materialPrice": 1902,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_36_Lsh"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": 36,
      "config": "SSS",
      "configName": "Slanted Shoe Shelves",
      "className": "Tall Section",
      "price": 959,
      "materialPrice": 959,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_12_36_SSS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 12,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Tall Section",
      "price": 174,
      "materialPrice": 174,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "T_84_12_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 460,
      "materialPrice": 460,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_24_DH"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Tall Section",
      "price": 1441,
      "materialPrice": 1441,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_24_DRW4"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DRW5",
      "configName": "5 Drawers",
      "className": "Tall Section",
      "price": 1771,
      "materialPrice": 1771,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_24_DRW5"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 24,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Tall Section",
      "price": 563,
      "materialPrice": 563,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_24_FS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 24,
      "config": "FSS",
      "configName": "Flat Shoe Shelves",
      "className": "Tall Section",
      "price": 756,
      "materialPrice": 756,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_24_FSS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 540,
      "materialPrice": 540,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_36_DH"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Tall Section",
      "price": 1663,
      "materialPrice": 1663,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_36_DRW4"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DRW5",
      "configName": "5 Drawers",
      "className": "Tall Section",
      "price": 1835,
      "materialPrice": 1835,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_36_DRW5"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 36,
      "config": "ESS",
      "configName": "Elite Shoe Shelves",
      "className": "Tall Section",
      "price": 1723,
      "materialPrice": 1203,
      "nonMaterialPrice": 520,
      "perPricing": "Section +1P",
      "source": "T_84_16_36_ESS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 36,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Tall Section",
      "price": 739,
      "materialPrice": 739,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_36_FS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 36,
      "config": "FSS",
      "configName": "Flat Shoe Shelves",
      "className": "Tall Section",
      "price": 1027,
      "materialPrice": 1027,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_36_FSS"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Tall Section",
      "price": 2032,
      "materialPrice": 2032,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_16_36_Lsh"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 16,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Tall Section",
      "price": 207,
      "materialPrice": 207,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "T_84_16_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 24,
      "widthIn": 24,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 596,
      "materialPrice": 596,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_24_24_DH"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 24,
      "widthIn": 24,
      "config": "DHDr",
      "configName": "Double Hang w. Doors",
      "className": "Tall Section",
      "price": 904,
      "materialPrice": 904,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_84_24_24_DHDr"
    },
    {
      "class": "T",
      "heightIn": 84,
      "depthIn": 24,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Tall Section",
      "price": 273,
      "materialPrice": 273,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "T_84_24_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": 24,
      "config": "AngSh",
      "configName": "Angled Shelves",
      "className": "Tall Section",
      "price": 1161,
      "materialPrice": 1161,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_12_24_AngSh"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": 24,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 428,
      "materialPrice": 428,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_12_24_DH"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": 24,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Tall Section",
      "price": 558,
      "materialPrice": 558,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_12_24_FS"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": 24,
      "config": "FSS",
      "configName": "Flat Shoe Shelves",
      "className": "Tall Section",
      "price": 630,
      "materialPrice": 630,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_12_24_FSS"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": 36,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 509,
      "materialPrice": 509,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_12_36_DH"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": 36,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Tall Section",
      "price": 747,
      "materialPrice": 747,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_12_36_FS"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": 36,
      "config": "FSS",
      "configName": "Flat Shoe Shelves",
      "className": "Tall Section",
      "price": 855,
      "materialPrice": 855,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_12_36_FSS"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Tall Section",
      "price": 2130,
      "materialPrice": 2130,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_12_36_Lsh"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 12,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Tall Section",
      "price": 175,
      "materialPrice": 175,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "T_95_12_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 508,
      "materialPrice": 508,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_24_DH"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Tall Section",
      "price": 1442,
      "materialPrice": 1442,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_24_DRW4"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 24,
      "config": "DRW5",
      "configName": "5 Drawers",
      "className": "Tall Section",
      "price": 1621,
      "materialPrice": 1621,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_24_DRW5"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 24,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Tall Section",
      "price": 611,
      "materialPrice": 611,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_24_FS"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 24,
      "config": "FSS",
      "configName": "Flat Shoe Shelves",
      "className": "Tall Section",
      "price": 804,
      "materialPrice": 804,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_24_FSS"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 613,
      "materialPrice": 613,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_36_DH"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DRW4",
      "configName": "4 Drawers",
      "className": "Tall Section",
      "price": 1664,
      "materialPrice": 1664,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_36_DRW4"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 36,
      "config": "DRW5",
      "configName": "5 Drawers",
      "className": "Tall Section",
      "price": 1835,
      "materialPrice": 1835,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_36_DRW5"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 36,
      "config": "FS",
      "configName": "Flat Shelves",
      "className": "Tall Section",
      "price": 811,
      "materialPrice": 811,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_36_FS"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 36,
      "config": "FSS",
      "configName": "Flat Shoe Shelves",
      "className": "Tall Section",
      "price": 1099,
      "materialPrice": 1099,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_36_FSS"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Tall Section",
      "price": 2226,
      "materialPrice": 2226,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_16_36_Lsh"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 16,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Tall Section",
      "price": 208,
      "materialPrice": 208,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "T_95_16_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 24,
      "widthIn": 24,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 668,
      "materialPrice": 668,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_24_24_DH"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 24,
      "widthIn": 24,
      "config": "DHDr",
      "configName": "Double Hang w. Doors",
      "className": "Tall Section",
      "price": 1010,
      "materialPrice": 1010,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_24_24_DHDr"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 24,
      "widthIn": 36,
      "config": "DH",
      "configName": "Double Hang",
      "className": "Tall Section",
      "price": 819,
      "materialPrice": 819,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_24_36_DH"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 24,
      "widthIn": 36,
      "config": "DHDr",
      "configName": "Double Hang w. Doors",
      "className": "Tall Section",
      "price": 1292,
      "materialPrice": 1292,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "T_95_24_36_DHDr"
    },
    {
      "class": "T",
      "heightIn": 95,
      "depthIn": 24,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Tall Section",
      "price": 274,
      "materialPrice": 274,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "T_95_24_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 12,
      "widthIn": 24,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 312,
      "materialPrice": 312,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_12_24_ShDr"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 12,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 207,
      "materialPrice": 207,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_12_24_ShOp"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 12,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Upper Section",
      "price": 1412,
      "materialPrice": 1412,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_12_36_LSh"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 418,
      "materialPrice": 418,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_12_36_ShDr"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 280,
      "materialPrice": 280,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_12_36_ShOp"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 12,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Upper Section",
      "price": 57,
      "materialPrice": 57,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "U_24_12_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 16,
      "widthIn": 24,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 358,
      "materialPrice": 358,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_16_24_ShDr"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 16,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 254,
      "materialPrice": 254,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_16_24_ShOp"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 16,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Upper Section",
      "price": 1192,
      "materialPrice": 1192,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_16_36_LSh"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 16,
      "widthIn": 36,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 482,
      "materialPrice": 482,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_16_36_ShDr"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 16,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 344,
      "materialPrice": 344,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_24_16_36_ShOp"
    },
    {
      "class": "U",
      "heightIn": 24,
      "depthIn": 16,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Upper Section",
      "price": 68,
      "materialPrice": 68,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "U_24_16_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": 24,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 441,
      "materialPrice": 441,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_12_24_ShDr"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 298,
      "materialPrice": 298,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_12_24_ShOp"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Upper Section",
      "price": 1482,
      "materialPrice": 1482,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_12_36_LSh"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 593,
      "materialPrice": 593,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_12_36_ShDr"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 399,
      "materialPrice": 399,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_12_36_ShOp"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 12,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Upper Section",
      "price": 91,
      "materialPrice": 91,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "U_36_12_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 16,
      "widthIn": 24,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 505,
      "materialPrice": 505,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_16_24_ShDr"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 16,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 362,
      "materialPrice": 362,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_16_24_ShOp"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 16,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Upper Section",
      "price": 1511,
      "materialPrice": 1511,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_16_36_LSh"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 16,
      "widthIn": 36,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 680,
      "materialPrice": 680,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_16_36_ShDr"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 16,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 486,
      "materialPrice": 486,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_36_16_36_ShOp"
    },
    {
      "class": "U",
      "heightIn": 36,
      "depthIn": 16,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Upper Section",
      "price": 107,
      "materialPrice": 107,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "U_36_16_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 12,
      "widthIn": 24,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 703,
      "materialPrice": 703,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_12_24_ShDr"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 12,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 405,
      "materialPrice": 405,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_12_24_ShOp"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 12,
      "widthIn": 36,
      "config": "Lsh",
      "configName": "L-Shelves",
      "className": "Upper Section",
      "price": 1482,
      "materialPrice": 1482,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_12_36_LSh"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 703,
      "materialPrice": 703,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_12_36_ShDr"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 12,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 467,
      "materialPrice": 467,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_12_36_ShOp"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 12,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Upper Section",
      "price": 91,
      "materialPrice": 91,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "U_42_12_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 16,
      "widthIn": 24,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 549,
      "materialPrice": 549,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_16_24_ShDr"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 16,
      "widthIn": 24,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 373,
      "materialPrice": 373,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_16_24_ShOp"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 16,
      "widthIn": 36,
      "config": "ShDr",
      "configName": "Shelving with Doors",
      "className": "Upper Section",
      "price": 807,
      "materialPrice": 807,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_16_36_ShDr"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 16,
      "widthIn": 36,
      "config": "ShOp",
      "configName": "Open Shelving",
      "className": "Upper Section",
      "price": 504,
      "materialPrice": 504,
      "nonMaterialPrice": 0,
      "perPricing": "Section +1P",
      "source": "U_42_16_36_ShOp"
    },
    {
      "class": "U",
      "heightIn": 42,
      "depthIn": 16,
      "widthIn": null,
      "config": "P",
      "configName": "Panel",
      "className": "Upper Section",
      "price": 107,
      "materialPrice": 107,
      "nonMaterialPrice": 0,
      "perPricing": "Panel",
      "source": "U_42_16_3/4_P",
      "panelThicknessIn": 0.75
    },
    {
      "class": "WB",
      "heightIn": 50,
      "depthIn": 20,
      "widthIn": 80,
      "config": "Bd TwH",
      "configName": "Twin Wall bed Horizontal",
      "className": "Wall Bed Section",
      "price": 3904,
      "materialPrice": 1904,
      "nonMaterialPrice": 2000,
      "perPricing": "Section +2P",
      "source": "WB_50_20_80_Bd TwH"
    },
    {
      "class": "WB",
      "heightIn": 87.7,
      "depthIn": 20,
      "widthIn": 64,
      "config": "BdQnV",
      "configName": "Queen Wall bed Vertical",
      "className": "Wall Bed Section",
      "price": 3905,
      "materialPrice": 1905,
      "nonMaterialPrice": 2000,
      "perPricing": "Section +2P",
      "source": "WB_87.7_20_64_BdQnV"
    }
  ]
});

/** Material-level multiplier curve from the M_Lvl calibration rows (plan §1.2). */
export const CV_MATERIAL_MULTIPLIERS = Object.freeze({
  "baseMaterialPrice": 174,
  "levels": [
    {
      "level": 1,
      "factor": 1
    },
    {
      "level": 2,
      "factor": 1.149
    },
    {
      "level": 3,
      "factor": 1.31
    },
    {
      "level": 4,
      "factor": 1.5
    },
    {
      "level": 5,
      "factor": 1.816
    },
    {
      "level": 6,
      "factor": 2.264
    },
    {
      "level": 7,
      "factor": 2.753
    },
    {
      "level": 8,
      "factor": 3.006
    },
    {
      "level": 9,
      "factor": 3.305
    },
    {
      "level": 10,
      "factor": 4.046
    }
  ]
});

/** Countertop pricing: $ per contiguous top + per-sq-ft material rates (plan §1.3). */
export const CV_COUNTERTOPS = Object.freeze({
  "fixedChargePerCountertop": {
    "price": 55,
    "materialPrice": 0,
    "nonMaterialPrice": 55,
    "source": "CT_Fixed Charge",
    "per": "countertop piece (each contiguous top)"
  },
  "materials": [
    {
      "code": "CT_0.5_12_12_Thinscape",
      "materialCode": "Thinscape",
      "name": "Thinscape",
      "perSqFt": 88,
      "thicknessIn": 0.5,
      "per": "sq ft"
    },
    {
      "code": "CT_0.75_12_12_Mel Lvl 1",
      "materialCode": "Mel Lvl 1",
      "name": "Mel Lvl 1",
      "perSqFt": 25,
      "thicknessIn": 0.75,
      "per": "sq ft"
    },
    {
      "code": "CT_0.75_12_12_Mel Lvl 2",
      "materialCode": "Mel Lvl 2",
      "name": "Mel Lvl 2",
      "perSqFt": 28,
      "thicknessIn": 0.75,
      "per": "sq ft"
    },
    {
      "code": "CT_0.75_12_12_Mel Lvl 3",
      "materialCode": "Mel Lvl 3",
      "name": "Mel Lvl 3",
      "perSqFt": 30,
      "thicknessIn": 0.75,
      "per": "sq ft"
    },
    {
      "code": "CT_0.75_12_12_Mel Lvl 4",
      "materialCode": "Mel Lvl 4",
      "name": "Mel Lvl 4",
      "perSqFt": 33,
      "thicknessIn": 0.75,
      "per": "sq ft"
    },
    {
      "code": "CT_0.75_12_12_Mel Lvl 5",
      "materialCode": "Mel Lvl 5",
      "name": "Mel Lvl 5",
      "perSqFt": 38,
      "thicknessIn": 0.75,
      "per": "sq ft"
    },
    {
      "code": "CT_1.25_12_12_Qtz Lvl 1",
      "materialCode": "Qtz Lvl 1",
      "name": "Qtz Lvl 1",
      "perSqFt": 115,
      "thicknessIn": 1.25,
      "per": "sq ft"
    },
    {
      "code": "CT_1.25_12_12_Qtz Lvl 2",
      "materialCode": "Qtz Lvl 2",
      "name": "Qtz Lvl 2",
      "perSqFt": 160,
      "thicknessIn": 1.25,
      "per": "sq ft"
    },
    {
      "code": "CT_1.5_12_12_Lam CF",
      "materialCode": "Lam CF",
      "name": "Lam CF",
      "perSqFt": 72,
      "thicknessIn": 1.5,
      "per": "sq ft"
    },
    {
      "code": "CT_1.5_12_12_Lam Chain",
      "materialCode": "Lam Chain",
      "name": "Lam Chain",
      "perSqFt": 60,
      "thicknessIn": 1.5,
      "per": "sq ft"
    },
    {
      "code": "CT_1.5_12_12_Lam Solicor",
      "materialCode": "Lam Solicor",
      "name": "Lam Solicor",
      "perSqFt": 97,
      "thicknessIn": 1.5,
      "per": "sq ft"
    },
    {
      "code": "CT_1.5_12_12_Lam Spec Ord",
      "materialCode": "Lam Spec Ord",
      "name": "Lam Spec Ord",
      "perSqFt": 77,
      "thicknessIn": 1.5,
      "per": "sq ft"
    }
  ]
});

/** The accessories the sketch tool prices today (plan §1.3 + mapping doc §1). */
export const CV_ACCESSORIES = Object.freeze([
  {
    "key": "elite-toe-stop",
    "name": "Elite Toe Stop",
    "price": 52
  },
  {
    "key": "lit-shelf",
    "name": "Lit Shelf",
    "price": 180
  },
  {
    "key": "tilt-out-hamper-18",
    "name": "Tilt-out Hamper 18",
    "price": 168.32,
    "group": "hamper",
    "hamperWidthIn": 18
  },
  {
    "key": "tilt-out-hamper-24",
    "name": "Tilt-out Hamper 24",
    "price": 203.95,
    "group": "hamper",
    "hamperWidthIn": 24
  },
  {
    "key": "tilt-out-hamper-30",
    "name": "Tilt-out Hamper 30",
    "price": 218.05,
    "group": "hamper",
    "hamperWidthIn": 30
  },
  {
    "key": "tilt-out-wire-18",
    "name": "Tilt Out Wire 18",
    "price": 235,
    "group": "hamper",
    "hamperWidthIn": 18
  },
  {
    "key": "tilt-out-wire-24",
    "name": "Tilt Out Wire 24",
    "price": 305,
    "group": "hamper",
    "hamperWidthIn": 24
  },
  {
    "key": "pull-out-nylon-18",
    "name": "Pull Out Nylon 18",
    "price": 246.96,
    "group": "hamper",
    "hamperWidthIn": 18
  },
  {
    "key": "pull-out-nylon-24",
    "name": "Pull Out Nylon 24",
    "price": 284.37,
    "group": "hamper",
    "hamperWidthIn": 24
  },
  {
    "key": "pull-out-nylon-30",
    "name": "Pull Out Nylon 30",
    "price": 328.58,
    "group": "hamper",
    "hamperWidthIn": 30
  },
  {
    "key": "pull-out-cloth-door",
    "name": "Pull Out Cloth (+ door)",
    "price": 952.25,
    "group": "hamper",
    "hamperWidthIn": null
  }
]);
